import React from 'react';

import { useI18n } from 'lib/i18n/context';
import ContractVerificationForm from 'ui/contractVerification/ContractVerificationForm';
import { getContractVerificationTitle } from 'ui/contractVerification/i18n';
import useFormConfigQuery from 'ui/contractVerification/useFormConfigQuery';
import ContentLoader from 'ui/shared/ContentLoader';
import DataFetchAlert from 'ui/shared/DataFetchAlert';
import PageTitle from 'ui/shared/Page/PageTitle';

const ContractVerification = () => {
  const { t } = useI18n();
  const configQuery = useFormConfigQuery(true);

  const content = (() => {
    if (configQuery.isError) {
      return <DataFetchAlert/>;
    }

    if (configQuery.isPending) {
      return <ContentLoader/>;
    }

    return (
      <ContractVerificationForm config={ configQuery.data }/>
    );
  })();

  return (
    <>
      <PageTitle
        title={ getContractVerificationTitle(t) }
        titleFontSize={{ base: '24px', lg: '36px' }}
        titleLineHeight={{ base: '31px', lg: '40px' }}
      />
      { content }
    </>
  );
};

export default ContractVerification;
